import * as React from "react";
import classNames from "classnames";
import { CircularProgressbarSvg } from "./CircularProgressbarSvg";

interface IStepCategoryViewProps {
  flowCategories: string[];
  category: string;
  categoryIndex: number;
  nextCategory?: string;
  allFlowCategories: string[];
  showAllAsFinished: boolean;
}

export const StepCategoryView = (props: IStepCategoryViewProps) => {
  const numberOfSteps = props.allFlowCategories?.length;
  const classes = classNames({
    step: true,
    "step--visited": props.flowCategories.indexOf(props.category) >= 0,
    "step--active": props.flowCategories.indexOf(props.category) === props.flowCategories.length - 1
  });

  return (
    <>
      <span className={classes} data-category={props.category}>
        <span className="counter-step" role="img" aria-hidden="true">
          {props.categoryIndex + 1}
        </span>
        <span className="counter-step-mobile">
          <CircularProgressbarSvg
            currentStep={props.showAllAsFinished ? numberOfSteps : props.categoryIndex + 1}
            totalSteps={numberOfSteps}
          />
        </span>

        <span className="counter-text">
          <div className="counter-text__title">{props.category}</div>
          {props.category !== "Uitkomst" && props.category !== "Nakijken en Versturen" && (
            <span className="next-step-counter-text-mobile"> {`Volgende: ${props.nextCategory}`} </span>
          )}
        </span>
      </span>
    </>
  );
};
